import { OperationTypeMoveTypeEnum } from '@zaoblako/shared/modules/document/enums/operation.type.move.type.enum';
import { OperationTypeMoveTypeEnumI18n } from '@zaoblako/shared/modules/document/i18n/operation-type-move-type-enum.i18n';
import { TaskKindEnum } from '@zaoblako/shared/modules/task/enum/task-kind.enum';
import { TaskKindEnumI18n } from '@zaoblako/shared/modules/task/i18n/task-kind-enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { DocumentCheckersEnum } from '@zaoblako/shared/modules/document/enums/document-checkers.enum';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import type { AccountingAccountFindInterface } from '@zaoblako/shared/modules/catalog/dtos/accounting-account/accounting-account-find.dto';

import * as yup from 'yup';

/** Operation type create or update request body */
export interface OperationTypeFormInterface {
  /** Operation type name from 1C ERP database */
  name: string;
  /** Operation type's movement type */
  type: OperationTypeMoveTypeEnum;
  /** BRS task kind. Using by BRS tasks to find this operation type and send it to 1C ERP database. */
  brsTaskKind?: TaskKindEnum;
  /** If `true` then documents with this operation type will be ignored in document compare report */
  ignoreInDocumentCompare?: boolean;
  /** Accounting accounts for operation type */
  accountingAccounts?: AccountingAccountFindInterface[];
  /** If `true` then all new native 1C ERP operation types will be assigned to this operation type */
  forUndistributed?: boolean;
}

export const OperationTypeFormDto = SerdeDtoClass.create<OperationTypeFormInterface>(DocumentDtoKeysEnum.OPERATION_TYPE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup.string().min(1, DtoMessageEnum.EMPTY_STRING),
    checkers: [DocumentCheckersEnum.OPERATION_TYPE_NAME_UNIQUE],
  },
  type: {
    label: 'Движение ДС',
    serializer: commonEnumValidator(OperationTypeMoveTypeEnum, OperationTypeMoveTypeEnumI18n),
  },
  brsTaskKind: {
    optional: true,
    label: 'Вид заявок на платеж',
    serializer: commonEnumValidator(TaskKindEnum, TaskKindEnumI18n),
    checkers: [DocumentCheckersEnum.OPERATION_TYPE_BRS_TASK_KIND_UNIQUE],
  },
  ignoreInDocumentCompare: {
    sortable: true,
    optional: true,
    label: 'Не учитывать в сверке оборотов',
    serializer: yup.boolean(),
  },
  accountingAccounts: {
    optional: true,
    label: 'Бухгалтерские счета',
    serializer: yup.array(entityLikeSchema),
    checkers: [CatalogCheckersEnum.ACCOUNTING_ACCOUNT_ASSERT_EXISTS_BY_DTO],
  },
  forUndistributed: {
    optional: true,
    label: 'Нераспределенные',
    serializer: yup.boolean(),
  },
});
